import React, { lazy, Suspense } from "react";
import FooterLogo from "../../assets/Logo/Raahi_Sathi_Logo.png";
import { FaLocationArrow, FaMobileAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const SocialMediaIcons = lazy(() => import("./SocialMediaIcons"));

const CompanyLinks = [
  { title: "Home", link: "/" },
  { title: "About Us", link: "/about" },
  { title: "Privacy Policy", link: "/privacy-policy" },
  { title: "Terms & Conditions", link: "/terms" },
  { title: "Careers", link: "/careers" },
];

const ServicesLinks = [
  { title: "Round-Trip Cabs", link: "/round-trip" },
  { title: "One-Way Drops", link: "/one-way" },
  { title: "Local Rent", link: "/local-rent" },
  { title: "Airport Transfers", link: "/airport-transfers" },
  { title: "Refunds", link: "/refunds" },
];

const Footer = () => {
  return (
    <footer className="bg-background dark:bg-darkBackground dark:border-t dark:border-secondary  text-primary dark:text-darkText py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Section */}
          <div>
            <img
              src={FooterLogo}
              alt="Raahi Sathi Logo"
              className="h-16 rounded-lg mx-auto md:mx-0"
              loading="lazy"
            />
            <p className="mt-4 text-sm text-secondary dark:text-darkAccent text-center md:text-left">
              Har raahi ke liye, ek sacha sathi — <strong className="text-primary dark:text-darkAccent">RAAHISATHI!</strong>
            </p>
            <div className="mt-4 space-y-2 text-center md:text-left">
              <div className="flex items-center gap-2 justify-center md:justify-start">
                <FaLocationArrow className="text-secondary dark:text-darkAccent" />
                <p>Bangalore, Karnataka</p>
              </div>
              <div className="flex items-center gap-2 justify-center md:justify-start">
                <FaMobileAlt className="text-secondary dark:text-darkAccent" />
                <p>
                  <a href="tel:08088342470" className="hover:text-secondary dark:hover:text-darkAccent">
                    080 8834 2470
                  </a>
                </p>
              </div>
            </div>
            {/* Social Media Icons */}
            <Suspense fallback={<div>Loading...</div>}>
              <SocialMediaIcons />
            </Suspense>
          </div>

          {/* Links Sections */}
          <div className="flex justify-between items-center">
            {[{ title: "Company", links: CompanyLinks }, { title: "Services", links: ServicesLinks }].map(
              ({ title, links }, index) => (
                <div key={index}>
                  <h3 className="text-lg font-semibold mb-4 text-secondary dark:text-darkAccent text-justify md:text-justify">{title}</h3>
                  <ul className="space-y-2 text-justify md:text-justify">
                    {links.map(({ title, link }, idx) => (
                      <li key={idx}>
                        <Link
                          to={link}
                          className="hover:text-gray-400 dark:hover:text-darkAccent transition"
                          aria-label={title}
                        >
                          {title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      {/* Copyright */}
      <div className="text-center py-2 bg-primary dark:bg-darkAccent text-secondary dark:text-darkBackground mt-6">
        <p>&copy; {new Date().getFullYear()} RAAHISATHI. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;